import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarSquare = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 20,
		rx: 4,
		fill: "currentColor",
		fillOpacity: .2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.05116 5.85118C9.44334 4.67271 9.63943 4.08347 10 4.08347C10.3606 4.08347 10.5567 4.67271 10.9488 5.85118L11.1971 6.59708C11.4169 7.25753 11.5267 7.58775 11.7887 7.77666C12.0507 7.96556 12.3987 7.96556 13.0947 7.96556H13.8619C15.1516 7.96556 15.7964 7.96556 15.9074 8.31375C16.0183 8.66194 15.4924 9.03502 14.4405 9.78119L13.8821 10.1773C13.2998 10.5903 13.0087 10.7968 12.9061 11.1105C12.8034 11.4241 12.9161 11.7628 13.1415 12.4401L13.3614 13.1007C13.7593 14.2964 13.9583 14.8943 13.667 15.11C13.3757 15.3257 12.8618 14.9612 11.834 14.2321L11.1572 13.752C10.5982 13.3554 10.3187 13.1572 10 13.1572C9.68133 13.1572 9.40184 13.3554 8.84284 13.752L8.16604 14.2321C7.13819 14.9612 6.62426 15.3257 6.333 15.11C6.04174 14.8943 6.2407 14.2964 6.63862 13.1007L6.85846 12.4401C7.08386 11.7628 7.19656 11.4241 7.09391 11.1105C6.99126 10.7968 6.70015 10.5903 6.11793 10.1773L5.55951 9.78119C4.50763 9.03502 3.98169 8.66194 4.09265 8.31375C4.2036 7.96556 4.84843 7.96556 6.13809 7.96556H6.90526C7.60132 7.96556 7.94935 7.96556 8.2113 7.77666C8.47325 7.58775 8.58315 7.25753 8.80294 6.59708L9.05116 5.85118Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgStarSquare);
export { ForwardRef as ReactComponent };
